import script from "./ContentDiscoveryPage.vue?vue&type=script&lang=js"
export * from "./ContentDiscoveryPage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__